
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
wx,XTextarea,Group
},
data() {
return {
subStatus: true,
popUp: false,
rechargePop: false,
orderShow: false,
clotheShow: false,
colorShow: false,
flawShow: false,
bagCode:'',
amount:'',
order_no:'',
type:0,
memberInfo:{},
queriedMemberPhone:'',
storeInfo:{},
settlementOptions:[],
consumeType:'',
preferredConsumeType:'',
freeIds:[],
recordPayVisible:false,
recordPayInfo:{},
recordPayTimer:null,
wxReady:false,
lastOrderQueryKey:'',
lastOrderQueryAt:0,
orderQueryLoading:false,
orderConfirmed:false,
confirmedOrderQueryKey:'',
recordTypes:[
{value:1,label:'收衣码录单'},
{value:2,label:'会员录单'},
{value:3,label:'非会员录单'},
],
order: {
community:{
name:''
},
},
name:'',
phone:'',
froms:[
{
code:'',
clothe_id:0,
cate_type:0,
color_id:0,
flaw_id:[],
clothe:'选择衣物',
flaw:'选择瑕疵',
color:'选择颜色',
price:0,
filePath: [],
pics:[],
remark:'',
}
],
clotheIndex:0,
colorIndex:0,
flawIndex:0,
picIndex:0,
clothes: [],
colors: [],
flaws: [],
info:{}
}
},
created() {
this.type = Number(this.$route.params.type);
this.order_no = this.$route.params.order_no;
this.phone = String(this.$route.query.phone || '').trim();
this.preferredConsumeType = String(this.$route.query.consumeType || '').trim();
if(this.order_no || this.type === 3){
this.getOrder();
}else if(this.type === 2 && this.phone){
this.getOrder();
}
this.config();
},
mounted(){
this.getInfo();
if(this.type === 2 && this.phone && !this.memberInfo.uid){
this.queryMember();
}
},
beforeDestroy(){
this.stopRecordPayPolling();
},
computed:{
totalPrice(){
return this.froms.reduce((total,item)=>Number(item.cate_type) === 3 ? total : total + Number(item.price || 0),0).toFixed(2);
},
mainClotheCount(){
return this.froms.filter(item=>Number(item.clothe_id) > 0 && Number(item.cate_type) !== 3).length;
},
selectedFreeCount(){
return (this.memberInfo.userFree || []).reduce((total,item)=>{
return this.freeIds.indexOf(item.key) > -1 ? total + Number(item.num || 0) : total;
},0);
},
activeYearCard(){
return (this.memberInfo.card_list || []).find(item=>Number(item.type) === 3) || {};
},
isBankOrder(){
return Number((this.order && this.order.bank_order) || 0) === 1;
},
canStartRecord(){
if(this.type === 1){
const currentQueryKey = [this.type,this.bagCode || '',this.order_no || '',''].join('|');
return this.orderConfirmed
&& Number(this.order.id || 0) > 0
&& this.confirmedOrderQueryKey === currentQueryKey;
}
if(this.type === 2){
return Number(this.memberInfo.uid || 0) > 0
&& this.phone === this.queriedMemberPhone
&& Boolean(this.consumeType);
}
if(this.type === 3){
return Boolean(String(this.name || '').trim()) && /^(1)[0-9]{10}$/.test(String(this.phone || '').trim());
}
return false;
},
settlementLabel(){
if(this.type === 2 && this.consumeType === 'package') return '次卡扣次';
if(this.type === 2 && this.consumeType === 'year') return '年卡扣次';
if(this.type === 3 && Number(this.storeInfo.pay_way || 0) !== 1) return '到店结算';
return '合计';
},
settlementAmount(){
if(this.type === 2 && this.consumeType === 'package') return this.mainClotheCount + '次';
if(this.type === 2 && this.consumeType === 'year') return this.mainClotheCount + '件';
return '￥' + this.totalPrice;
}
},
methods: {
emptyClothe(){
return {code:'',clothe_id:0,cate_type:0,color_id:0,flaw_id:[],clothe:'选择衣物',flaw:'选择瑕疵',color:'选择颜色',price:0,filePath:[],pics:[],remark:''};
},
changeRecordType(type){
if(this.type === type){
return;
}
this.type = type;
this.order_no = '';
this.bagCode = '';
this.order = {community:{name:''}};
this.orderConfirmed = false;
this.confirmedOrderQueryKey = '';
this.memberInfo = {};
this.queriedMemberPhone = '';
this.settlementOptions = [];
this.consumeType = '';
this.freeIds = [];
this.name = '';
this.phone = '';
this.froms = [this.emptyClothe()];
this.$router.replace({name:'bagCodeRecord',params:{type:type}});
if(type === 3){
this.getOrder();
}
},
getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
clearPhone(){
this.phone = '';
this.memberPhoneChanged();
},
memberPhoneChanged(){
if(this.type !== 2 || !this.memberInfo.uid || this.phone === this.queriedMemberPhone){
return;
}
this.memberInfo = {};
this.queriedMemberPhone = '';
this.settlementOptions = [];
this.consumeType = '';
this.freeIds = [];
this.clothes = [];
this.froms.forEach(item=>{
item.price = 0;
});
},
refreshSelectedPrices(){
const goodsMap = {};
this.clothes.forEach(category=>{
(category.goods || []).forEach(goods=>{
goodsMap[goods.id] = {
price:Number(goods.price || 0),
cate_type:Number(goods.cate_type || category.cate_type || 0),
};
});
});
this.froms.forEach(item=>{
const goods = goodsMap[item.clothe_id];
item.price = goods ? goods.price : 0;
item.cate_type = goods ? goods.cate_type : Number(item.cate_type || 0);
});
},
cardTypeText(type){
const names = {1:'折扣卡',2:'储值卡',3:'年卡'};
return names[Number(type)] || '会员卡';
},
selectConsumeType(type){
this.consumeType = type;
if(type === 'package'){
this.freeIds = (this.memberInfo.userFree || []).map(item=>item.key);
}else{
this.freeIds = [];
}
},
toggleFree(key){
const index = this.freeIds.indexOf(key);
if(index > -1){
this.freeIds.splice(index,1);
}else{
this.freeIds.push(key);
}
},
addModules(){
this.froms.push(this.emptyClothe());
},
removeModules(index){
this.froms.splice(index, 1);
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
if(key > 0){
that.froms[index].code = that.$func.parseScanResult(res.resultStr);
}else{
that.orderQueryChanged();
that.bagCode = that.$func.parseScanResult(res.resultStr);
that.getOrder();
}
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
orderQueryChanged(){
if(this.type !== 1){
return;
}
const hadOrder = this.orderConfirmed || Number(this.order.id || 0) > 0;
this.orderConfirmed = false;
this.confirmedOrderQueryKey = '';
this.order = {community:{name:''}};
this.memberInfo = {};
if(hadOrder){
this.froms = [this.emptyClothe()];
}
},
clearOrderQuery(field){
this[field] = '';
this.orderQueryChanged();
},
getOrder() {
if(this.orderQueryLoading){
return;
}
if(this.type <= 1 && !String(this.bagCode || '').trim() && !String(this.order_no || '').trim()){
this.$func.showToast('请输入订单号或收衣码');
return;
}
const params = {code:this.bagCode,order_no:this.order_no,type:this.type};
if(this.type === 2){
params.phone = this.phone;
}
const queryKey = [params.type,params.code || '',params.order_no || '',params.phone || ''].join('|');
const now = Date.now();
if(queryKey === this.lastOrderQueryKey && now - this.lastOrderQueryAt < 500){
return;
}
this.lastOrderQueryKey = queryKey;
this.lastOrderQueryAt = now;
this.orderQueryLoading = true;
if(this.type === 1){
this.orderConfirmed = false;
this.confirmedOrderQueryKey = '';
this.order = {community:{name:''}};
}
this.$api.getRecordOrder(params).then((res)=>{
if(res){
const responseData = res.data || {};
this.clothes = responseData.goods || [];
this.colors = responseData.colors || [];
this.flaws = responseData.flaw || [];
this.storeInfo = responseData.store || {};
this.memberInfo = responseData.member || {};
if(this.type === 2 && this.memberInfo.uid){
this.name = this.memberInfo.name || '';
this.phone = this.memberInfo.phone || this.phone;
this.queriedMemberPhone = this.phone;
this.refreshSelectedPrices();
this.settlementOptions = responseData.settlement_options || [];
const preferred = this.preferredConsumeType;
const canUsePreferred = (responseData.settlement_options || []).some(item=>item.value === preferred);
this.consumeType = canUsePreferred ? preferred : '';
this.freeIds = this.consumeType === 'package' ? (this.memberInfo.userFree || []).map(item=>item.key) : [];
this.preferredConsumeType = '';
}
if(this.type <= 1 && responseData.order && responseData.order.id){
this.order = responseData.order;
this.popUp = true;
this.orderShow = true;
}
}
this.orderQueryLoading = false;
},()=>{
this.orderQueryLoading = false;
})
},
queryMember(){
if(!this.phone){
this.$func.showToast('请输入会员手机号');
return;
}
this.getOrder();
},
getLastUserInfo() {
this.$api.getLastUserInfo({}).then((res)=>{
if(!res){
return;
}
const user = res && res.data ? res.data : {};
if(user.name && user.phone){
this.name = user.name;
this.phone = user.phone;
}else{
this.$func.showToast('暂无上一单用户信息');
}
})
},
openClotheShow(index){
this.clotheIndex = index;
this.popUp = true;
this.clotheShow = true;
},
openClotheColor(index){
this.colorIndex = index;
this.popUp = true;
this.colorShow = true;
},
openClotheFlaw(index){
this.flawIndex = index;
this.popUp = true;
this.flawShow = true;
},
closePop(){
this.popUp = false;
this.rechargePop = false;
this.orderShow = false;
this.clotheShow = false;
this.colorShow = false;
this.flawShow = false;
this.clotheIndex = 0;
this.colorIndex = 0;
this.flawIndex = 0;
this.amount = 0;
},
closeOverlay(){
if(!this.orderShow){
this.closePop();
}
},
confirmOrder(){
if(!this.order || !this.order.id){
return;
}
this.orderConfirmed = true;
this.confirmedOrderQueryKey = this.lastOrderQueryKey;
this.closePop();
},
clotheSelect(id,title,price,cateType){
this.froms[this.clotheIndex].clothe_id = id;
this.froms[this.clotheIndex].clothe = title;
this.froms[this.clotheIndex].cate_type = Number(cateType || 0);
this.froms[this.clotheIndex].price = Number(cateType) === 3 ? 0 : Number(price || 0);
this.closePop();
},
colorSelect(id,title){
this.froms[this.colorIndex].color_id = id;
this.froms[this.colorIndex].color = title;
this.closePop();
},
flawSelect(i,title){
let flawId = this.froms[this.flawIndex].flaw_id;
if(flawId){
if(flawId.indexOf(i) > -1){
flawId.splice(flawId.indexOf(i),1);
this.froms[this.flawIndex].flaw_id = flawId;
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
let flaw = this.froms[this.flawIndex].flaw_id;
this.froms[this.flawIndex].flaw = '';
flaw.forEach((item,index)=>{
this.froms[this.flawIndex].flaw += (index == flaw.length-1 ? this.flaws[item].title : this.flaws[item].title+',');
});
if(this.froms[this.flawIndex].flaw_id.length < 1){
this.froms[this.flawIndex].flaw = '选择瑕疵';
}
},
submit() {
if(!this.subStatus){
return false;
}
if(this.type === 1 && (!this.orderConfirmed || !this.order.id)){
this.$func.showToast('请先查询并确认订单信息');
return false;
}
if(this.type === 2 && (!this.memberInfo.uid || this.phone !== this.queriedMemberPhone)){
this.$func.showToast('请先查询会员');
return false;
}
if(this.type === 2 && !this.consumeType){
this.$func.showToast('请选择扣费方式');
return false;
}
if(this.type === 3 && !String(this.name || '').trim()){
this.$func.showToast('请输入姓名');
return false;
}
if(this.type === 3 && !/^(1)[0-9]{10}$/.test(String(this.phone || '').trim())){
this.$func.showToast('请正确输入手机号');
return false;
}
if(this.type === 2 && this.consumeType === 'package' && !this.freeIds.length){
this.$func.showToast('请选择次卡');
return false;
}
if(this.mainClotheCount < 1){
this.$func.showToast('请至少选择一件主件衣物');
return false;
}
if(this.type === 2 && this.consumeType === 'package' && this.mainClotheCount > this.selectedFreeCount){
this.$func.showToast('所选次卡数量不足');
return false;
}
if(this.type === 2 && this.consumeType === 'year'){
const dailyLimit = Number(this.activeYearCard.daily_wash_limit || 0);
if(dailyLimit > 0 && this.mainClotheCount > Number(this.memberInfo.year_today_remain || 0)){
this.$func.showToast('年卡今日剩余洗涤数量不足');
return false;
}
const yearGoodsIds = String(this.activeYearCard.wash_goods_ids || '').split(',').filter(Boolean).map(Number);
const invalid = yearGoodsIds.length && this.froms.some(item=>Number(item.cate_type) !== 3 && yearGoodsIds.indexOf(Number(item.clothe_id)) < 0);
if(invalid){
this.$func.showToast('所选衣物不适用于该年卡');
return false;
}
}
this.subStatus = false;
this.$func.startLoading('提交中...');
this.$api.submitRecord({order_id:this.order.id,cid:this.order.cid,name:this.name,phone:this.phone,record_type:this.type,consumeType:this.consumeType,freeIds:this.freeIds.join(','),clothe:JSON.stringify(this.froms)}).then((res)=>{
this.$func.endLoading();
if(res){
if(res.data && res.data.pay_type && String(res.data.pay_type).indexOf('wechat_jsapi') === 0){
this.startRecordWechatPay(res.data);
}else{
this.finishRecordSubmit();
}
}else{
this.subStatus = true;
}
}).catch(()=>{
this.$func.endLoading();
this.subStatus = true;
})
},
finishRecordSubmit(){
this.$func.showToast('提交成功');
this.order_no = '';
setTimeout(()=>{
window.location.reload();
},300);
},
startRecordWechatPay(payInfo){
this.recordPayInfo = payInfo || {};
this.recordPayVisible = true;
this.stopRecordPayPolling();
this.recordPayTimer = setInterval(()=>this.checkRecordPayStatus(false),2000);
if(this.recordPayInfo.pay_type === 'wechat_jsapi_mock'){
this.$func.showToast('本地模拟支付，请模拟回调');
return;
}
if(!this.wxReady || !wx || typeof wx.chooseWXPay !== 'function'){
this.handleRecordPayFailure('微信支付初始化失败，请刷新页面重试');
return;
}
wx.chooseWXPay({
timestamp: String(this.recordPayInfo.timeStamp),
nonceStr: this.recordPayInfo.nonceStr,
package: this.recordPayInfo.package,
signType: this.recordPayInfo.signType || 'MD5',
paySign: this.recordPayInfo.paySign,
success: ()=> this.checkRecordPayStatus(false),
cancel: ()=> this.handleRecordPayFailure('已取消微信支付'),
fail: ()=> this.handleRecordPayFailure('微信支付调起失败')
});
},
handleRecordPayFailure(message){
this.stopRecordPayPolling();
this.recordPayVisible = false;
this.subStatus = true;
this.$func.showToast(message);
},
stopRecordPayPolling(){
if(this.recordPayTimer){
clearInterval(this.recordPayTimer);
this.recordPayTimer = null;
}
},
checkRecordPayStatus(showTip){
if(!this.recordPayInfo.order_no){
return;
}
this.$api.recordPayStatus({order_no:this.recordPayInfo.order_no}).then((res)=>{
if(res && res.data && res.data.paid){
this.stopRecordPayPolling();
this.recordPayVisible = false;
this.finishRecordSubmit();
}else if(showTip){
this.$func.showToast('暂未查询到支付成功');
}
});
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"scanQRCode",
"chooseWXPay"
]
});
wx.ready(()=>{ this.wxReady = true; });
wx.error(()=>{ this.wxReady = false; });
}
})
},
uploadFile(index){
let that = this;
this.picIndex = index;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
if(!localIds || !localIds.length){
return false;
}
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
if(res){
that.froms[that.picIndex].filePath.push(res.data.pathName);
that.froms[that.picIndex].pics.push(res.data.saveName);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(i,index) {
wx.previewImage({
current: this.froms[i].filePath[index],
urls: [this.froms[i].filePath[index]]
});
},
delImg(i,index){
this.froms[i].filePath.splice(index,1);
this.froms[i].pics.splice(index,1);
},
openRecharge(){
this.rechargePop = true;
this.popUp = true;
},
recharge(){
if(this.amount <= 0){
this.$func.showToast('请输入充值金额');
return false;
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady();
}
},
onBridgeReady(){
let that = this;
this.$api.recharge({money:this.amount}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.getInfo();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/bagCodeRecord.vue